import React from 'react';
import { useHistory } from 'react-router-dom';
import { Container } from '~/components/layout/PageStructure';
import { LiveReplaysContainer } from '~/components/live/live-replays/LiveReplaysContainer';

const LiveReplaysModule: React.FC = () => {
  const history = useHistory();

  return (
    <Container>
      <div className={'mt-6'}>
        <LiveReplaysContainer
          onReplayClick={(id: number) => history.push(`/live/${id}`)}
        />
      </div>
    </Container>
  );
};

export { LiveReplaysModule };
